<template>
  <span class="text-red">*</span>
</template>

